import 'normalize.css'
import 'animate.css/animate.min.css'

import './src/styles/fonts.css'
import './src/styles/typography.css'
import './src/styles/redesign/typography-redesign.css'
import './src/styles/redesign/colors-redesign.css'
import './src/styles/redesign/global.css'
import './src/styles/colors.css'
import './src/styles/offsets.css'
import './src/styles/utils.css'

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  const rawEnv = process.env.RESTIK_ENV;
  let isProduction = rawEnv === 'production';
  // Fallback heuristic if env is not defined at build-time
  if (typeof rawEnv === 'undefined') {
    try {
      const host = window.location.hostname || '';
      isProduction = host === 'restik.com';
    } catch (_) {}
  }
  const appId = isProduction ? 'mhu4cp5z' : 'r3q86vl1';

  // Allow overriding script URL; if contains {APP_ID} placeholder, replace it. Otherwise use defaults.
  let scriptUrl = isProduction
      ? 'https://help.restik.com/_icwidget/widget/mhu4cp5z'
      : 'https://dev-help.restik.com/_icwidget/widget/r3q86vl1';

  const delayMs = 3000;

  // Expose settings before loading script (some widgets auto-read this)
  window.intercomSettings = {
    app_id: appId,
    api_base: isProduction
      ? 'https://help.restik.com/_icapi'
      : 'https://dev-help.restik.com/_icapi',
  };

  // If Intercom already present, update settings and reattach
  if (typeof window.Intercom === 'function') {
    window.Intercom('reattach_activator');
    window.Intercom('update', window.intercomSettings);
    return;
  }

  // Load the widget script after the shim; do not override window.Intercom with a stub
  const d = document;
  const actuallyLoad = () => {
    if (d.getElementById('intercom-script')) {
      return;
    }
    const s = d.createElement('script');
    s.id = 'intercom-script';
    s.type = 'text/javascript';
    s.async = true;
    s.src = scriptUrl;
    // Append to head to avoid coming before the shim script
    (d.head || d.body || d.documentElement).appendChild(s);
  };

  const loadScript = () => {
    if (d.readyState === 'loading') {
      d.addEventListener('DOMContentLoaded', actuallyLoad, { once: true });
    } else {
      actuallyLoad();
    }
  };

  // Delay load to mimic previous plugin option
  if (delayMs > 0) {
    setTimeout(loadScript, delayMs);
  } else {
    loadScript();
  }
};

export const onRouteUpdate = () => {
  if (typeof window === 'undefined') return;
  if (typeof window.Intercom === 'function') {
    try {
      window.Intercom('update');
    } catch (e) {
      // noop
    }
  }
};
